import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { getBalanceAndPin } from "../../features/balance-and-pin/balanceAndPinSlice";
import Spinner from "../../components/Spinner";
import {
  IntroSection,
  MainContainer,
  SectionContainer,
  Footer
} from "./styles";

import intro from "./images/logo.svg";
import wearable from "./images/wearable.png";
import digiseqLogo from "./images/digiseq-logo.png";

const Hsbc26 = () => {
  const [searchParams] = useSearchParams();
  const serialNumber = searchParams.get("serialNumber");
  const provider = searchParams.get("provider");
  const place = searchParams.get("place");
  const defaultRate = parseFloat(searchParams.get("rate"));
  const rateSGD = parseFloat(searchParams.get("rateSGD")) || defaultRate;
  const rateHKD = parseFloat(searchParams.get("rateHKD")) || defaultRate;

  const formatCurrency = (usdAmount, placeValue) => {
    const usdFormatted = `US$${usdAmount}`;
    if (!placeValue || (!rateSGD && !rateHKD)) return usdFormatted;
    const rate = placeValue === "singapore" ? rateSGD : placeValue === "hongkong" ? rateHKD : null;
    if (!rate) return usdFormatted;
    const localAmount = (parseFloat(usdAmount) * rate).toFixed(2);
    const localSymbol = placeValue === "singapore" ? "S$" : "HK$";
    return `${usdFormatted} / ${localSymbol}${localAmount}`;
  };

  const dispatch = useDispatch();
  const { balanceAndPin, isLoading } = useSelector(
    (state) => state.balanceAndPin
  );

  useEffect(() => {
    if (!balanceAndPin && serialNumber) {
      dispatch(
        getBalanceAndPin({
          serial: serialNumber,
          query: `?provider=${provider || "much_better"}`
        })
      );
    }
  }, [balanceAndPin, serialNumber, dispatch, provider]);

  if (isLoading) return <Spinner />;

  return (
    <MainContainer>
      <IntroSection>
        <div className="intro-logo">
          <img src={intro} alt="intro" />
        </div>
        <h1>Welcome to your Priceless Experience</h1>
        <div className="intro-content">
          <p>
            We’re thrilled to have you here — get ready for an unforgettable
            evening!
          </p>
          <p>
            Your <strong>HSBC Mastercard keyring wearable</strong> is preloaded
            with {formatCurrency(25, place)} to make your night even more special.
          </p>
          <p>
            Whether it’s a drink, a snack, or a little something extra, just{" "}
            <strong>tap and enjoy!</strong>
          </p>
        </div>
      </IntroSection>
      <SectionContainer>
        <div className="balance-container">
          <h2>Your Balance</h2>
          <p className="balance-value">
            {balanceAndPin?.balanceDetails?.availableBalance
              ? formatCurrency(balanceAndPin.balanceDetails.availableBalance, place)
              : "N/A"}
          </p>
          <p>
            <i>
              Your balance will update automatically after each transaction.
            </i>
          </p>
        </div>
      </SectionContainer>
      <SectionContainer>
        <div className="how-it-works">
          <div className="wearable-container">
            <img src={wearable} alt="wearable" />
          </div>
          <h2>How It Works</h2>
          <p>
            Your keyring is preloaded with <strong>{formatCurrency(25, place)}</strong>. Simply{" "}
            <strong> tap it on any contactless payment terminal </strong> where
            Mastercard Contactless is enabled to make a purchase.
          </p>
          <p>
            If you make a purchase in a currency other than US$, the amount will
            be converted using the{" "}
            <strong>
              foreign exchange rate in effect on the date of the transaction.
            </strong>{" "}
            Any unused balance will remain available for use at any merchants
            after the event.
          </p>
        </div>
      </SectionContainer>
      <SectionContainer>
        <div className="priceless-link-container">
          {place === "singapore" && (
            <p>
              Tap the button below to discover more HSBC Singapore Priceless
              Experiences
            </p>
          )}
          {place === "hongkong" && (
            <p>
              HSBC Mastercard unlock the door to international music
              extravaganza. Tap the button below to discover more HSBC
              Mastercard Priceless Experiences
            </p>
          )}
          <a
            href={
              place === "singapore"
                ? "https://www.priceless.com/HSBCSG"
                : place === "hongkong"
                  ? "https://www.priceless.com/HSBCHK"
                  : "https://www.priceless.com/HSBCSG"
            }
            target="_blank"
            rel="noreferrer"
          >
            <div className="priceless-link">Explore now</div>
          </a>
        </div>
      </SectionContainer>

      <Footer>
        <p>Powered by</p>
        <img
          src={digiseqLogo}
          alt="digiseq"
          onClick={() =>
            window.open(
              "https://www.digiseq.co.uk",
              "_blank noreferrer noopener"
            )
          }
        />
      </Footer>
    </MainContainer>
  );
};

export default Hsbc26;
